import React, { useState } from 'react';
import { formatDocumentTypeLabel } from '../../utils/documentTypes';

function resolveTargetDocType(hypothesis, docTypes) {
  if (!docTypes?.length) return hypothesis?.type;
  const hint = (hypothesis?.type || '').toLowerCase();
  const match = docTypes.find(
    (t) =>
      t.document_type.toLowerCase().includes(hint) ||
      formatDocumentTypeLabel(t.document_type).toLowerCase().includes(hint) ||
      hint.includes(t.document_type.toLowerCase())
  );
  return match?.document_type || docTypes[0]?.document_type;
}

export default function ClassifyCard({
  hypothesis,
  aiSummary,
  docTypes = [],
  onConfirm,
  onChooseOther,
  loading = false,
}) {
  const [showPicker, setShowPicker] = useState(false);
  const label = formatDocumentTypeLabel(hypothesis?.type) || 'tipo sugerido';
  const conf = hypothesis?.confidence
    ? `${Math.round(hypothesis.confidence * 100)}%`
    : null;

  return (
    <div className="dv-classify-card">
      <h4 className="dv-classify-title">Confirmar tipo de comprobante</h4>
      <p className="dv-classify-hypothesis">
        Mejor hipótesis: <strong>{label}</strong>
        {conf && <span className="dv-classify-conf"> ({conf} confianza)</span>}
      </p>
      {aiSummary && <p className="dv-classify-summary">{aiSummary}</p>}

      {!showPicker ? (
        <div className="dv-classify-actions">
          <button
            type="button"
            className="dv-btn-primary"
            disabled={loading || !docTypes.length}
            onClick={() => onConfirm?.(resolveTargetDocType(hypothesis, docTypes))}
          >
            Confirmar como {label}
          </button>
          <button
            type="button"
            className="dv-btn-secondary"
            disabled={loading}
            onClick={() => setShowPicker(true)}
          >
            Elegir otro tipo
          </button>
        </div>
      ) : (
        <div className="dv-classify-picker">
          <label htmlFor="dv-type-select">Tipo de documento</label>
          <select
            id="dv-type-select"
            className="dv-select"
            defaultValue=""
            onChange={(e) => {
              if (e.target.value) onChooseOther?.(e.target.value);
            }}
          >
            <option value="" disabled>
              Seleccionar…
            </option>
            {docTypes.map((t) => (
              <option key={t.document_type} value={t.document_type}>
                {formatDocumentTypeLabel(t.document_type)}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="dv-btn dv-btn-ghost"
            onClick={() => setShowPicker(false)}
          >
            Cancelar
          </button>
        </div>
      )}
    </div>
  );
}
